import React from 'react'

const ProReviews = () => {
  return (
    <div className='lg:max-w-3xl lg:mx-auto' id='reviews'>
      <h2 className='text-4xl font-bold text-center text-[#333] md:pb-6 tracking-3 leading-160 toppan'>お客様の声</h2>
      <div className='my-8 relative rounded-[25px] border-[1.5px] border-[#333] p-5 sm:p-8 mt-14'>
        <p className='text-xl text-left text-[#333] leading-170'>
          ただホームページのリニューアルをするだけでなく、ウェブの知識が全くない私たちのために管理の仕方等も親身に教えてくださりありがとうございました。デザインも良くなり、新規患者数も増え、非常に満足しております。今後ともどうぞよろしくお願いします。
        </p>
        <div className='pt-4'>
          <p className='text-sm text-right text-[#555] leading-170'>
            医療法人財団村上医院
          </p>
          <p className='text-sm text-right text-[#555] leading-170'>村上</p>
        </div>
        <svg
          width={95}
          height={95}
          viewBox='0 0 95 95'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='w-[70px] h-[70px] absolute left-[-12px] top-[-35px]'
          preserveAspectRatio='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M37.3133 18.0421C22.4102 27.6133 14.1313 38.7521 12.4748 51.4643C9.89591 71.25 27.5897 80.9341 36.5553 72.2337C45.5209 63.5313 40.1475 52.4875 33.6558 49.4673C27.1641 46.4491 23.1939 47.5 23.8866 43.4645C24.5794 39.431 33.8141 28.2447 41.9287 23.0355C42.2163 22.791 42.3997 22.446 42.4417 22.0709C42.4836 21.6958 42.3808 21.3188 42.1544 21.0168L40.1475 18.4063C39.2766 17.2742 38.4414 17.3177 37.3133 18.0401M76.5523 18.0421C61.6491 27.6133 53.3683 38.7541 51.7137 51.4643C49.1349 71.25 66.8286 80.9341 75.7942 72.2337C84.7599 63.5313 79.3864 52.4875 72.8928 49.4673C66.4011 46.4491 62.4309 47.5 63.1236 43.4645C63.8163 39.431 73.0531 28.2447 81.1677 23.0355C81.4549 22.7907 81.638 22.4456 81.6796 22.0705C81.7211 21.6954 81.618 21.3185 81.3913 21.0168L79.3845 18.4063C78.5136 17.2742 77.6784 17.3177 76.5523 18.0401'
            fill='#0CBFD3'
          />
        </svg>
        <svg
          width={95}
          height={95}
          viewBox='0 0 95 95'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='w-[70px] h-[70px] absolute right-[-10px] top-[-35px]'
          preserveAspectRatio='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M57.6867 76.9579C72.5898 67.3867 80.8687 56.2479 82.5252 43.5357C85.1041 23.75 67.4103 14.0659 58.4447 22.7663C49.4791 31.4687 54.8525 42.5125 61.3442 45.5327C67.8359 48.5509 71.8061 47.5 71.1134 51.5355C70.4206 55.569 61.1859 66.7553 53.0713 71.9645C52.7837 72.209 52.6003 72.554 52.5583 72.9291C52.5164 73.3042 52.6192 73.6812 52.8456 73.9832L54.8525 76.5937C55.7234 77.7258 56.5586 77.6823 57.6867 76.9599M18.4477 76.9579C33.3509 67.3867 41.6317 56.2459 43.2863 43.5357C45.8651 23.75 28.1714 14.0659 19.2058 22.7663C10.2401 31.4687 15.6136 42.5125 22.1072 45.5327C28.5989 48.5509 32.5691 47.5 31.8764 51.5355C31.1837 55.569 21.9469 66.7553 13.8323 71.9645C13.5451 72.2093 13.362 72.5544 13.3204 72.9295C13.2789 73.3046 13.382 73.6815 13.6087 73.9832L15.6155 76.5937C16.4864 77.7258 17.3216 77.6823 18.4477 76.9599'
            fill='#0CBFD3'
          />
        </svg>
      </div>
    </div>
  )
}

export default ProReviews